import React, { useState, useEffect } from "react";
// import Spinner from "../components/UI/Spinner/Spinner";
// import PasswordToolbar from "../components/PageComponents/HomeSection/subcomponents/PasswordToolbar";
// import Footer from "../../HOC/Footer/Footer";
import Logo from "../../Resources/Images/LoginPage.png";
import { Formik, Form, Field } from "formik";
// import * as Yup from "yup";
import { NavLink, useNavigate } from "react-router-dom";
// import { AiFillInstagram } from "react-icons/ai";
// import { BsTwitter, BsWhatsapp } from "react-icons/bs";
// import { FaFacebookF, FaTiktok } from "react-icons/fa";
import { forgotPasswordSchema } from "../../UI/RegxSchema/RegXSchema";
import Loader from "../../components/pageComponents/Spinner/loader";
import axios from "../../HOC/Axios/Axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaTradeFederation } from "react-icons/fa";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
function ForgotPassword() {
  const [showSpinner, setShowSpinner] = useState(false);
  const [showPassword, setShowPassword] = useState({});

  const navigate = useNavigate();
  const updatePassword = [
    {
      label: "email",
      type: "text",
      apikey: "email",
      placeholder: "Enter your email address",
    },

    {
      label: "old password",
      type: "password",
      apikey: "oldPassword",
      placeholder: "Enter old Password",
      icon1: <AiFillEye />,
      icon2: <AiFillEyeInvisible />,
    },
    {
      label: "new password",
      type: "password",
      apikey: "newPassword",
      placeholder: "Enter new Password",
      icon1: <AiFillEye />,
      icon2: <AiFillEyeInvisible />,
    },
    {
      label: "confirm new password",
      type: "password",
      apikey: "confirmNewPassword",
      placeholder: "Confirm your new Password",
      icon1: <AiFillEye />,
      icon2: <AiFillEyeInvisible />,
    },
  ];

  const handleSubmit = async (values, resetForm) => {
    console.log(values);
    setShowSpinner(true);
    try {
      let response = await axios.patch("/admin/changepassword", values);
      console.log(response);
      toast.success("Password updated sucessfully", { toastId: "Error" });
      setInterval(() => {
        if (response.status === 200) {
          setShowSpinner(false);
          navigate("/login");
          resetForm();
        }
      }, 300);
    } catch (error) {
      setShowSpinner(false);
      toast.error(error.message, { toastId: "Error" });
    }
  };
  const [ID, setID] = useState({});
  const handleClicked = (apikey) => {
    setID((prev) => ({ ...prev, [apikey]: true }));
  };
  const handleInputBlur = (e, apikey) => {
    if (e.target.value.length > 0) {
      setID((prev) => ({ ...prev, [apikey]: true }));
    } else {
      setID((prev) => ({ ...prev, [apikey]: false }));
    }
  };
  const handleHidePassword = (apikey) => {
    setShowPassword({ ...showPassword, [apikey]: false });
  };
  const handleShowPassword = (apikey) => {
    setShowPassword({ ...showPassword, [apikey]: true });
  };
  useEffect(() => {
    // Disable scrolling when the component mounts
    document.body.style.overflow = "hidden";

    // Re-enable scrolling when the component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div className="tablet:grid grid-cols-12 tablet:h-fit min-h-screen bg-gray-50">
      <div className="hidden tablet:block col-span-7 relative w-full">
        <ToastContainer autoClose={1000} pauseOnHover={false} />
        {showSpinner ? <Loader /> : null}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent z-10" />
        <div className="absolute left-[10%] top-[200px] z-20">
          <div className="text-4xl font-bold tracking-tight text-white drop-shadow-lg">
            Secure Your Account
          </div>
          <div className="text-base text-white/90 mt-5 max-w-md leading-relaxed">
            Keep your admin credentials safe by updating your password regularly.
          </div>
        </div>
        <img
          alt="Security"
          src={Logo}
          width={100}
          height={10}
          className="h-[820px] w-full object-cover overflow-hidden object-top"
        />
      </div>
      <div className="col-span-5 px-8 py-12 flex items-start justify-center h-screen overflow-auto tablet:h-full flex-col bg-white">
        <div className="w-11/12 mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="bg-gradient-to-br from-secondMainColor to-indigo-600 rounded-xl p-2.5 shadow-lg shadow-secondMainColor/25">
              <FaTradeFederation className="text-5xl text-white" />
            </div>
            <div className="capitalize text-2xl tracking-tight text-gray-800 font-bold">
              Update
              <br /> your password
            </div>
          </div>

          <Formik
            initialValues={{
              email: "",
              oldPassword: "",
              newPassword: "",
              confirmNewPassword: "",
            }}
            validationSchema={forgotPasswordSchema}
            onSubmit={(values, { resetForm }) => {
              handleSubmit(values, resetForm);
            }}
          >
            {({ errors, touched, values }) => (
              <Form>
                <div className="px-0 py-2 text-sm text-gray-600 mb-4">
                  You can change your password immediately because you are logged into your email account on this browser.
                </div>
                <div className="px-5 ">
                  {updatePassword.map((val, i) => {
                    return (
                      <div className=" my-4 relative " key={i}>
                        <label
                          onClick={() => handleClicked(val.apikey)}
                          htmlFor={val.apikey}
                          className={` absolute tracking-wider 
                            ${
                              ID[val.apikey] || values[val.apikey]
                                ? "top-2 text-[12px] font-normal"
                                : "top-6 text-[14px] font-medium"
                            } font-normal
                           left-5 transition-all ease-in-out duration-300 text-gray-500 `}
                        >
                          {val.placeholder}
                        </label>
                        <div className="">
                          <Field
                            onFocus={() => handleClicked(val.apikey)}
                            onBlur={(e) => handleInputBlur(e, val.apikey)}
                            id={val.apikey}
                            type={
                              val.type === "password" &&
                              !showPassword[val.apikey]
                                ? "password"
                                : "text"
                            }
                            name={val.apikey}
                            // placeholder={val.placeholder}
                            className="px-4 my-2 h-12 outline-none border border-gray-200 rounded-lg w-full bg-white focus:ring-2 focus:ring-secondMainColor/20 focus:border-secondMainColor"
                          />
                          <div className="absolute top-7 right-5 cursor-pointer">
                            {showPassword[val.apikey] ? (
                              <div
                                onClick={() => handleHidePassword(val.apikey)}
                              >
                                {val.icon1}
                              </div>
                            ) : (
                              <div
                                onClick={() => handleShowPassword(val.apikey)}
                              >
                                {val.icon2}
                              </div>
                            )}
                          </div>
                        </div>
                        {errors[val.apikey] && touched[val.apikey] ? (
                          <div className=" text-red-400 text-sm px-2  rounded-sm">
                            {errors[val.apikey]}
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
                <div className="gap-4 py-4">
                  <button
                    type="submit"
                    className="w-full h-12 px-4 bg-secondMainColor hover:bg-secondMainColor/90 text-white font-semibold rounded-lg transition-colors shadow-lg shadow-secondMainColor/25 flex items-center justify-center"
                  >
                    Update Password
                  </button>
                  <NavLink to={"/login"} className="block text-center mt-4">
                    <span className="text-secondMainColor hover:text-secondMainColor/80 font-medium hover:underline transition-colors">
                      Back to login
                    </span>
                  </NavLink>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
